import type { PartnerEnum } from '../groveSchedulerClient'
import type { PartnerSchemaInternal } from './types'

/**
 * Open Dental partner configuration schema.
 *
 * Open Dental agents do not require user-configurable registration fields.
 * The `customer_key` is server-provisioned via Partner Ops (`POST /open_dental/customer_key`)
 * on agent creation and should be displayed read-only on the detail page for onboarding.
 * The Open Dental developer key is server-managed (Secrets Manager) and is not part of
 * agent registration.
 */
export const openDentalSchema: PartnerSchemaInternal = {
  partner: 'open_dental' as PartnerEnum,
  displayName: 'Open Dental',
  fields: [], // No user-configurable fields - backend handles setup
}
